import formatData from "../utils/formatData";
const formatChallengeData = function(id, item) {
  const data = item;
  data.id = id;
  data.startDateText = item.startDate.toDate();
  data.endDateText = item.endDate.toDate();
  data.isCompleted = item.endDate.toDate() < Date.now() ? true : false;
  data.isStarted = item.startDate.toDate() < Date.now() ? true : false;
  //suport form
  data.startDateDatepicker = formatData("datepicker", item.startDate.toDate());
  data.endDateDatepicker = formatData("datepicker", item.endDate.toDate());
  data.details = formatData("trucatedText", item.details);
  data.maxMember = item.maxMember !== undefined ? item.maxMember : 0;
  data.maxGroupMember = item.maxGroupMember !== undefined ? item.maxGroupMember : 0;

  // if (data.summary != undefined) {
  //   data.summaryMemberNumbersKeyDisplay = [];
  //   data.summaryMemberNumbersValueDisplay = [];
  //   if( data.summary.memberNumbers != undefined ){
  //       Object.entries(data.summary.memberNumbers).map(async ([key, item]) => {
  //         data.summaryMemberNumbersKeyDisplay.push(formatData('capitalize', key));
  //         data.summaryMemberNumbersValueDisplay.push(item);
  //       });
  //   }
  // }
  return data;
};
export default formatChallengeData;
